export function injectReducers(reducers) {
    return (dispatch, getState) =>
    {
        dispatch({ type: 'STORE_INJECT', reducers: reducers });
    }
}


// WEBPACK FOOTER //
// ./Portico/App/actions/Registry.js